import React from 'react';

interface PartProps {
    part: {
        name: string;
        dimensions?: string | null;
        material?: string | null;
        finish?: string | null;
        coating?: string | null;
    };
}

const Property = (props: { label: string; value: string }) => {
    const { label, value } = props;

    return (
        <div className={'flex flex-row'}>
            <div className={'font-bold'}>{label}:</div>
            <div className={'font'}>{value}</div>
        </div>
    );
};

const Part = (props: PartProps) => {
    const { name, dimensions, material, finish, coating } = props.part;

    return (
        <div className={'flex flex-col itemsCenter'}>
            <div className={'flex xl:flex-row sm:flex-col'}>
                <div className="font-bold">{name}</div>
                <div className="italic text-xs xl:ml-2">{dimensions}</div>
            </div>

            <div className={'flex flex flex-col'}>
                {material && <Property label="Material" value={material} />}
                <div className={'flex  xl:flex-row sm:flex-col'}>
                    {coating && (
                        <div>
                            <Property label="Coating" value={coating} />
                        </div>
                    )}
                    {finish && (
                        <div className={'xl:ml-2'}>
                            <Property label="Finish" value={finish} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Part;
